"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthService = void 0;
const axios_1 = require("axios");
const endpoints_1 = require("../config/endpoints");
const index_1 = require("../index");
const index_2 = require("../index");
class AuthService {
    loginUser(email, password) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { data: result } = yield axios_1.default.post(`${endpoints_1.STARCK_API}/auth/login`, {
                    email,
                    password,
                }, {
                    timeout: 20000,
                });
                this.setUser(result.user, result.accessToken, result.refreshToken);
                result.user.role = result.user.role.split(',');
                return result;
            }
            catch (error) {
                throw error;
            }
        });
    }
    logoutUser() {
        try {
            index_1.Storage.removeItem('currentUser');
            index_1.cookieStorage.removeItem('accessToken');
            index_1.cookieStorage.removeItem('refreshToken');
            return true;
        }
        catch (error) {
            throw error;
        }
    }
    signupUserFb(userFb) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: result } = yield index_2.httpService.get(
            // eslint-disable-next-line @typescript-eslint/camelcase
            { access_token: userFb.accessToken, referralId: index_1.Storage.getItem('referralId') || '' }, { url: endpoints_1.STARCK_API + '/auth/facebook', authorized: false });
            this.setUser(result.user, result.accessToken, result.refreshToken);
            result.user.role = result.user.role.split(',');
            return result;
        });
    }
    reauthUser(accessToken, refreshToken) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { data: result } = yield axios_1.default.post(`${endpoints_1.STARCK_API}/auth/token`, { refreshToken }, {
                    timeout: 20000,
                    headers: { Authorization: 'bearer ' + accessToken },
                });
                this.setUser(result.user, result.accessToken, refreshToken);
                this.setAccessToken(result.accessToken);
                result.user.role = result.user.role.split(',');
                return result;
            }
            catch (error) {
                throw error;
            }
        });
    }
    setAccessToken(accessToken) {
        return index_1.cookieStorage.setItem('accessToken', accessToken);
    }
    getCurrentUser() {
        const userStringified = index_1.Storage.getItem('currentUser');
        if (userStringified) {
            const user = JSON.parse(userStringified);
            user.role = user.role.split(',');
            return user;
        }
    }
    getAccessToken() {
        let accessToken = index_1.cookieStorage.getItem('accessToken');
        if ((accessToken && typeof accessToken === 'undefined') || accessToken === null) {
            accessToken = index_1.Storage.getItem('accessToken');
        }
        return accessToken;
    }
    getRefreshToken() {
        return index_1.cookieStorage.getItem('refreshToken');
    }
    setUser(user, accessToken, refreshToken) {
        index_1.Storage.setItem('currentUser', JSON.stringify(user));
        index_1.Storage.setItem('accessToken', accessToken);
        index_1.cookieStorage.setItem('accessToken', accessToken);
        index_1.cookieStorage.setItem('refreshToken', refreshToken);
    }
    verify(verificationCode) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { data: result } = yield axios_1.default({
                    method: 'POST',
                    url: endpoints_1.STARCK_API + '/user/verify',
                    timeout: 5000,
                    data: {
                        verificationCode,
                    },
                });
                return result;
            }
            catch (error) {
                throw error;
            }
        });
    }
}
exports.AuthService = AuthService;
